<template>
    <keep-alive>
    <div class="index_wrap">
        <div style="margin-bottom: 20px;">
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="index_item_top">
                        <div class="index_item_tit">
                            <p><img src="../../assets/myWillDo.png"><span>服务台的待办</span></p>
                            <div class="item_tit_right">
                                <el-button @click="agencyCompleteFn('125')" :class="agency.status == '125'? 'isActive' : ''" >未办</el-button>
                                <el-button @click="agencyCompleteFn('135')" :class="agency.status == '135'? 'isActive' : ''" >已办</el-button>
                            </div>
                        </div>
                        <div class="index_item_content myAgency">
                            <el-table class="settingHeight" :data="myAgencyData" >
                                <el-table-column label="名称" prop="title"  show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="类别" prop="type"></el-table-column>
                                <el-table-column label="日期" prop="time"></el-table-column>
                            </el-table>
                            <el-pagination small @size-change="agencySize"
                                           @current-change="agencyCurrent"
                                           :current-page="agency.pageIndex"
                                           :page-sizes="[10,20]"
                                           :pager-count="5"
                                           :page-size="agency.pageSize"
                                           layout="total, sizes, prev, pager, next, jumper"
                                           :total="agencyTotal">
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="index_item_top">
                        <div class="index_item_tit">
                            <p><img src="../../assets/myApply.png"><span>我的请求</span></p>
                            <div class="item_tit_right">
                                <el-button @click="requestCompleteFn('0')" :class="request.complete == '0'? 'isActive' : ''" >未办</el-button>
                                <el-button @click="requestCompleteFn('1')" :class="request.complete == '1'? 'isActive' : ''" >已办</el-button>
                            </div>
                        </div>
                        <div class="index_item_content my_event">
                            <el-table class="settingHeight" :data="myRequestData" >
                                <el-table-column label="名称" prop="title" >
                                    <template slot-scope="scope">
                                        <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="类别" prop="type"></el-table-column>
                                <el-table-column label="日期" prop="time"></el-table-column>
                            </el-table>
                            <el-pagination small @size-change="requestSize"
                                           @current-change="requestCurrent"
                                           :current-page="request.pageIndex"
                                           :page-sizes="[10,20]"
                                           :pager-count="5"
                                           :page-size="request.pageSize"
                                           layout="total, sizes, prev, pager, next, jumper"
                                           :total="requestTotal">
                            </el-pagination>
                        </div>
                    </div>
                </el-col>

            </el-row>
<!--            <div class="index_item">-->
<!--                <div class="index_item_tit">-->
<!--                    <p><img src="../../assets/myWillDo.png"><span>服务台的待办</span></p>-->
<!--                    <div class="item_tit_right">-->
<!--                        <el-button @click="agencyCompleteFn('125')" :class="agency.status == '125'? 'isActive' : ''" >未办</el-button>-->
<!--                        <el-button @click="agencyCompleteFn('135')" :class="agency.status == '135'? 'isActive' : ''" >已办</el-button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="index_item_content myAgency">-->
<!--                    <el-table class="settingHeight" :data="myAgencyData" >-->
<!--                        <el-table-column label="名称" prop="title"  show-overflow-tooltip>-->
<!--                            <template slot-scope="scope">-->
<!--                                <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="类别" prop="type"></el-table-column>-->
<!--                        <el-table-column label="日期" prop="time"></el-table-column>-->
<!--                    </el-table>-->
<!--                    <el-pagination @size-change="agencySize"-->
<!--                                   @current-change="agencyCurrent"-->
<!--                                   :current-page="agency.pageIndex"-->
<!--                                   :page-sizes="[10,20]"-->
<!--                                   :page-size="agency.pageSize"-->
<!--                                   layout="total, sizes, prev, pager, next, jumper"-->
<!--                                   :total="agencyTotal">-->
<!--                    </el-pagination>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="index_item">-->
<!--                <div class="index_item_tit">-->
<!--                    <p><img src="../../assets/myApply.png"><span>我的请求</span></p>-->
<!--                    <div class="item_tit_right">-->
<!--                        <el-button @click="requestCompleteFn('0')" :class="request.complete == '0'? 'isActive' : ''" >未办</el-button>-->
<!--                        <el-button @click="requestCompleteFn('1')" :class="request.complete == '1'? 'isActive' : ''" >已办</el-button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="index_item_content my_event">-->
<!--                    <el-table class="settingHeight" :data="myRequestData" >-->
<!--                        <el-table-column label="名称" prop="title" >-->
<!--                            <template slot-scope="scope">-->
<!--                                <p @click="toCorrectDetail(scope.row.serialNumber)" style="color: #1890ff;cursor: pointer;">{{scope.row.title}}</p>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="类别" prop="type"></el-table-column>-->
<!--                        <el-table-column label="日期" prop="time"></el-table-column>-->
<!--                    </el-table>-->
<!--                    <el-pagination @size-change="requestSize"-->
<!--                                   @current-change="requestCurrent"-->
<!--                                   :current-page="request.pageIndex"-->
<!--                                   :page-sizes="[10,20]"-->
<!--                                   :page-size="request.pageSize"-->
<!--                                   layout="total, sizes, prev, pager, next, jumper"-->
<!--                                   :total="requestTotal">-->
<!--                    </el-pagination>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="myKnowledgeMes">
            <div>
                <span>知识搜索</span>
                <router-link :to="{ path: '/searchKnowledge' }">
                    <el-button type="text" class="rightDistance">常用知识</el-button>
                </router-link>
                <router-link :to="{ path: '/knowledgeList' }">
                    <el-button type="text" class="rightDistance">我的知识</el-button>
                </router-link>
                <el-input v-model="queryMes" class="searchInput" placeholder="关键字查询"></el-input>
                <el-button type="primary" @click="search">查询</el-button>
            </div>
            <div>
                <div v-show="index<12" v-for="(item,index) in knowledgeList" :key="index">
                    <router-link :to="{ path: '/knowledgeDetail',query:{message:item} }">
                        <div class="showBorder setPadding"><a href="javascript:void(0);">{{item.Title}}</a></div>
                    </router-link>
                    <div class="setPadding"><p v-html="item.Body">{{item.Body}}</p></div>
                </div>
            </div>
        </div>
    </div>
    </keep-alive>
</template>

<script>
    import services from "./index.service";
    import config from "../../app.config";
    // import KeepAlive from '../../core/components/keep-alive';
    export default {
        // components: {KeepAlive},
        data() {
            return {
                myAgencyData:[],           // 我的待办
                myRequestData:[],            //  我的请求
                myAgencyAllData:[],
                agency:{
                    pageIndex:1,
                    pageSize:10,
                    status:"125"
                },
                request:{
                    pageIndex:1,
                    pageSize:10,
                    complete:"0"
                },
                agencyTotal:null,

                requestTotal:null,
                knowledgeList:[],//知识搜索信息
                queryMes:'',//输入的关键字
                eventSource:null
            }
        },
        created() {
            this.$route.meta.KeepAlive = true
            // this.getAgencyList();
            this.sseEvent()
            this.getRequestList();
            this.search();
            // this.agencyListNotice()

        },
        mounted(){
            this.$route.meta.KeepAlive = true
            this.$store.commit('setKeepAlive',true);
            this.getAllReceptionOrders()
            // this.$nextTick(function(){
            //     this.getAllReceptionOrders()
            // })

        },
        computed:{
            userId:function () {
                return this.$store.state.userInfo.user.userId;
            },
            username:function () {
                return this.$store.state.userInfo.user.username
            },
            keepAliveflag(){
                return this.$store.state.keepAlive
            }
        },
        watch:{
            myAgencyAllData:{
                handler(newval,oldval){
                    // console.log('watch========')
                    if(newval){
                        this.agencyTotal = newval.length
                        this.agencyCurrent(1)
                    }
                },
                immediate:true
            }
        },
        methods: {
            sseEvent(){
                let _this = this
                if('EventSource' in window){
                    let sseurl = `${config.sseurl}?channel=wedof_itsm_reception`
                    this.eventSource = new EventSource(sseurl)
                    // if(this.eventSource){
                    //     this.$nextTick(function(){
                    //         setTimeout(function() {
                    //             _this.getAllReceptionOrders()
                    //         }, 500);
                    //     })
                    // }
                    this.eventSource.onopen = function(e){
                        console.log('连接打开')
                        console.log(e)
                        // _this.getAllReceptionOrders()
                    }
                    //全部服务台待办工单
                    // this.eventSource.addEventListener("all_reception_orders", function(event) {
                    //     const val = JSON.parse(event.data);
                    //     console.log('全部服务台待办工单')
                    //     _this.myAgencyAllData = val.list
                    //     _this.agencyTotal = val.list.length
                    //     _this.agencyCurrent(1)
                    // })
                    // 服务台添加待办工单
                    this.eventSource.addEventListener("reception_order", function(event) {
                        const val = JSON.parse(event.data);
                        console.log('待办工单')
                        // console.log(val)
                        _this.myAgencyAllData = [val, ..._this.myAgencyData]
                        // _this.myAgencyData = [val, ..._this.myAgencyData]
                        _this.agencyTotal++
                        _this.agencyCurrent(1)
                    })
                    //移除服务台待办工单
                    this.eventSource.addEventListener("remove_reception_order", function(event) {
                        const val = JSON.parse(event.data);
                        console.log('移除待办工单')
                        let newArray = _this.myAgencyAllData.filter(item=> item.serialNumber !== val.serialNumber)
                        console.log(newArray)
                        _this.myAgencyAllData = [...newArray]
                        // _this.myAgencyData = [...newArray]
                        _this.agencyTotal--
                        _this.agencyCurrent(1)
                    })
                    this.eventSource.onmessage = function(event) {
                        // to to something…
                        console.log("接收信息", event);
                    }

                    //对服务端断开链接的监听
                    this.eventSource.onerror = function(e){
                        console.log('onerror------------')
                        console.log(e)
                        if(e.currentTarget.readyState == EventSource.CLOSED){
                            console.log('连接关闭')
                            _this.sseEvent()
                            // _this.eventSource.close()
                        }else{
                            console.log('onerror:'+e.currentTarget.readyState)

                        }
                    }
                }else{
                    console.log('浏览器不支持sse')
                }
            },
            getAllReceptionOrders(){
                services.getReceptionOrders().then(res => {
                    console.log(res)
                    this.myAgencyAllData = res.list
                    this.agencyTotal = res.list.length
                    this.agencyCurrent(1)
                }).catch(err => {
                    this.$message.error(err.message);
                })

            },
            getAgencyList(){
                // let vm=this
                this.getAgencyInterval()
                // this.$interval(()=>{
                //     vm.getAgencyInterval()
                // },10000)
            },

            getAgencyInterval(){

                let params = {
                    ...this.agency,
                };
                services.getServiceCounterList(params).then(res => {
                    this.myAgencyData = res.list;
                    this.agencyTotal = res.total;
                }).catch(err => {
                    if (!this.errSum) {
                        this.$message.error(err.message);
                        this.errSum=1
                    }
                    // console.log(err);
                    // console.log(err.message);

                })
            },
            getRequestList(){
                // let vm=this
                this.getRequestInterval()
                // this.$interval(()=>{
                //     vm.getRequestInterval()
                // },10000)
            },
            getRequestInterval(){

                let params = {
                    ...this.request,
                    user:this.username,
                };
                services.getRequestList(params).then(res => {
                    this.myRequestData = res.list;
                    this.requestTotal = res.total;
                }).catch(err => {
                    if (!this.errSum) {
                        this.$message.error(err.message);
                        this.errSum=1
                    }
                    // console.log(err);
                    // this.$message.error(err.message);
                }).finally(() => {
                    this.requestLoading = false;
                })
            },
            agencyCompleteFn(val){
                this.agency.status = val;
                // console.log(val)
                if(val == '135'){
                    this.agency.pageIndex = 1
                    this.getAgencyList();
                }else{
                    this.getAllReceptionOrders()
                    this.agencyCurrent(1)
                }

            },
            requestCompleteFn(val){
                this.request.complete = val;
                this.getRequestList();
            },

            agencySize(val){
                let pages = Math.ceil(this.agencyTotal / val);
                this.agency.pageSize = val;
                if(this.agency.pageIndex > pages ){
                    this.agency.pageIndex  = 1;
                };
                this.getAgencyList()
            },
            agencyCurrent(val){
                // console.log(val)
                // console.log(this.agency.status)
                this.agency.pageIndex = val;
                if(this.agency.status == '135'){
                    this.getAgencyList();
                }else{
                    //125
                    let start = (this.agency.pageIndex - 1) * this.agency.pageSize;
                    let end = start + this.agency.pageSize;
                    this.myAgencyData = this.myAgencyAllData.slice(start, end);
                }

            },
            requestSize(val){
                let pages = Math.ceil(this.requestTotal / val);
                this.request.pageSize = val;
                if(this.request.pageIndex > pages ){
                    this.request.pageIndex  = 1;
                };
                this.getRequestList()
            },
            requestCurrent(val){
                this.request.pageIndex = val;
                this.getRequestList();
            },
            search(){//知识搜索
                services.knowledgeQuery({"Query":this.queryMes,"pageIndex":1,"pageSize":12}).then(res => {
                    this.knowledgeList = res.KnowledgeTable;
                }).catch(err => {
                    if (!this.errSum) {
                        this.$message.error(err.message);
                        this.errSum=1
                    }
                    // this.$message.error(err.message);
                })
            },
            //点击待办或请求中列表名称时跳转对应详情
            toCorrectDetail(val){
                let sn=val
                let hrefurl
                if (sn.indexOf('Eve')>-1) {
                    hrefurl = this.$router.resolve({path:'/eventDetail',query:{serialNumber:sn}})

                    // this.$router.push({path:'/eventDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Cha')>-1){
                    hrefurl = this.$router.resolve({path:'/changeDetail',query:{serialNumber:sn}})
                    // this.$router.push({path:'/changeDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Dep')>-1){
                    hrefurl = this.$router.resolve({path:'/deployDetail',query:{serialNumber:sn}})
                    // this.$router.push({path:'/deployDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Pro')>-1){
                    hrefurl = this.$router.resolve({path:'/problemDetail',query:{serialNumber:sn}})
                    // this.$router.push({path:'/problemDetail',query:{serialNumber:sn}})
                }
                if (sn.indexOf('Res')>-1){
                    hrefurl = this.$router.resolve({path:'/resourceApplyDetail',query:{serialNumber:sn}})
                }
                // console.log(hrefurl)
                window.open(hrefurl.href,'_blank')
            },
            //每次进首页都要判断待办消息提示
            // agencyListNotice(){
            //     if (this.myAgencyData){
            //         this.$notify.info({
            //             title:'新消息',
            //             message:'您有新的待办',
            //             position:'bottom-right',
            //             duration:7500,
            //             customClass:'noticeInform'
            //         })
            //     }
            // },

        },
        beforeDestroy() {
            if(this.eventSource){
                this.eventSource.close()
            }
        },
        beforeRouteLeave (to, from, next) {
            // console.log(to)
            // console.log(from)
           if (to.name === 'changeDetail') {  //  如果跳转是C单位选择页面，那就把当前B填写页面缓存起来。
            this.$store.commit('setKeepAlive', ['serviceCounter'])
          } else {
            this.$store.commit('setKeepAlive', [])　// 跳转其它页面则清除缓存
          }
          next()
        }
    }
</script>

<style lang="scss"  rel="stylesheet/scss">
    @import "./index";
    body{
        .index_item_top{
            background-color: white;
            border-radius:5px;
        }
        .noticeInform{
            background: #a8e0ff;
            .el-notification__content{
                font-size: 16px;
            }
            .el-notification__closeBtn{
                color: white;
                font-size: 20px;
                &:hover{
                    color: black;
                }
            }
        }
    }

</style>
